import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CheckOrganizationForSigningMutationResponse } from "../../types/CheckOrganizationForSigning";

/**
     * @link /api/ms-inputs-order-backend/private/v1/organization/do_check-for-signing
     */
export async function checkOrganizationForSigning (options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<CheckOrganizationForSigningMutationResponse>["data"]> {
    const { data: resData } = await client<CheckOrganizationForSigningMutationResponse>({
        method: "post",
        url: `/api/ms-inputs-order-backend/private/v1/organization/do_check-for-signing`,
        ...options
    });
    
    return resData;
};